import { useNavigate, Link } from "react-router-dom";
import { GlobalContext, Section } from "../lib/Root";
import { useContext, useEffect, useState } from "react";
import { Box, Button, TextField } from "@mui/material";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import axios from "../lib/Axios";
import { z } from "zod";

//Define validation parameters required for each field.
var schema = z.object({
	username: z.string().min(3, { message: "Minimum 3 Characters" })
				.max(20, { message: "Maximum 20 Characters" })
				.regex(/^[a-zA-Z0-9_-]+$/, { message: "Only letters, numbers, underscores & hypens" })
				.regex(/^[a-zA-Z]/, { message: "Must start with a letter." }),
	password: z.string()
				.min(8, "Minimum 8 Characters")
				.max(32, "Maximum 32 Characters")
				.regex(/[A-Z]/, "Must contain an uppercase letter")
				.regex(/[a-z]/, "Must contain a lowercase letter")
				.regex(/[0-9]/, "Must contain a number")
				.regex(/[^a-zA-Z0-9]/, "Must contain a special character"),
	email: z.string().email({ message: "Invalid Email Address" }),
});

export default function AccountRegister() {
	var _ = useContext(GlobalContext);
	useEffect(() => { _.document.title = "Register"; }, []);

	var navigate = useNavigate();

	var { register, handleSubmit, setError, formState: { errors, isSubmitting } } = useForm({
		resolver: zodResolver(schema)
	});

	//Used to display success message before redirect.
	var [success, setSuccess] = useState(false);

	if (_.user.id > 0) {
		return <Section small center>
			<p>You must logout to register a new account.</p>
			<p><Button variant="contained" onClick={() => navigate("/account/logout?redirect=/account/register")}>Logout</Button></p>
		</Section>
	}

	var onSubmit = async (data) => {
		return axios.post("/account/register", new URLSearchParams(data)).then(({ data }) => {
			if (!data || data.error) { throw new Error(!data ? "An unknown error occured." : data.error); }

			//Account registration successful.
			setSuccess(true);
		}).catch(e => {
			setError("root", { message: e.message });
		});
	}

	if (success) {
		return <Section small center>
			<p>Your registration was successful.</p>
			<p>A verification code has been sent to your email.</p>
			<Button onClick={() => navigate("/account/login")}>Login To Continue</Button>
		</Section>
	}

	return <Section small center>
		<Box component="form" onSubmit={handleSubmit(onSubmit)}>
			{errors.root && <div className="notice">{errors.root.message}</div>}
			<TextField {...register("username")} label="Username" autoComplete="off" error={!!errors.username} helperText={errors.username?.message} />
			<TextField {...register("email")} label="Email Address" autoComplete="off" error={!!errors.email} helperText={errors.email?.message} />
			<TextField {...register("password")} label="Password" type="password" autoComplete="new-password" error={!!errors.password} helperText={errors.password?.message} />
			<Button disabled={isSubmitting} type="submit">{isSubmitting ? "Processing" : "Register"}</Button>
			<span style={{display:"block"}}>Already have an account? <Link to="/account/login">Login!</Link></span>
		</Box>
	</Section>;
}